export const Speaner = () => {
  return (
    <div className='speaner loader fixed bg-black bg-opacity-50 left-0 z-50 before:fixed before:left-0 before:top-0 before:h-full before:w-full before:bg-black/80 before:content-[""]'>
      <span></span>
    </div>
  );
};
